import { ApolloClient } from '@apollo/client';
import { NormalizedCacheObject } from '@apollo/client';
import { loader } from 'graphql.macro';
import { logger } from 'logging-utils';
import {
  PolicySettingsInput,
  PolicySettingsResponse,
} from '../../policy-settings-types';

const mutation = loader('./set-policy-settings.gql');

const setPolicySettings = (client: ApolloClient<NormalizedCacheObject>) => {
  return {
    execute: async (policySettingsInput: PolicySettingsInput) => {
      try {
        const results = await client.mutate<{
          setPolicySettings: PolicySettingsResponse;
        }>({
          mutation,
          variables: { policySettingsInput },
        });

        return results?.data?.setPolicySettings?.hasModifiedSettings;
      } catch (error) {
        logger.error(
          `Failed to set policy settings for ${policySettingsInput.appIds.join(
            ',',
          )}`,
          error,
        );
        return null;
      }
    },
  };
};

export default setPolicySettings;
